module.exports = require("@wordpress/compose");